var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isLoading ? _c("Spinner", { attrs: { size: "medium" } }) : _vm._e(),
      !_vm.isLoading
        ? _c("div", { staticClass: "va-row" }, [
            _c(
              "div",
              { staticClass: "flex md12 xs12" },
              [
                _c("vuestic-widget", [
                  _c("div", { staticClass: "va-row" }, [
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-micro",
                          on: { click: _vm.updateUserData },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("translate")("basic.button.confirm")
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-pale btn-micro",
                          on: {
                            click: function ($event) {
                              return _vm.$router.back(-1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("translate")("basic.button.cancel")
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "va-row" }, [
              _c(
                "div",
                { staticClass: "flex md12 xs12" },
                [
                  _c(
                    "vuestic-widget",
                    {
                      attrs: {
                        headerText: _vm._f("translate")(
                          "userManagement.user.userInfomation.title"
                        ),
                      },
                    },
                    [
                      _c("fieldset", [
                        _c("div", { staticClass: "va-row" }, [
                          _c("div", { staticClass: "s-item" }, [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.$t("forms.wizard.name")) + "："
                              ),
                            ]),
                            _c("span", [_vm._v(_vm._s(_vm.userForm.name))]),
                          ]),
                          _c("div", { staticClass: "s-item" }, [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("auth.email")) + "："),
                            ]),
                            _c("span", [_vm._v(_vm._s(_vm.userForm.email))]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "vuestic-widget",
                    {
                      attrs: {
                        headerText: _vm._f("translate")(
                          "userManagement.user.authority.title"
                        ),
                        id: "formAuthority",
                      },
                    },
                    [
                      _c(
                        "fieldset",
                        [
                          _c("div", { staticClass: "flex md12 xs12" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "border-width": "0px 0px 1px 0px",
                                  "border-style": "solid",
                                  "border-color": "rgba(204, 204, 204, 1)",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "userManagement.user.authority.pages.title"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._l(_vm.userForm.pages, function (page, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "flex md12 xs12" },
                              [
                                _c("div", { staticClass: "va-row" }, [
                                  _c("div", { staticClass: "flex md4 p-l" }, [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.translatePageName(page.name))
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "flex md2" }),
                                  _c(
                                    "div",
                                    { staticClass: "flex md4" },
                                    [
                                      _c("vuestic-checkbox", {
                                        staticStyle: {
                                          display: "inline-flex",
                                          width: "100px",
                                        },
                                        attrs: { label: _vm.$t("view") },
                                        model: {
                                          value:
                                            _vm.createItems[index]
                                              .privileges[0],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.createItems[index].privileges,
                                              0,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "createItems[index].privileges[0]",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "flex md2" }),
                                ]),
                              ]
                            )
                          }),
                          _c("div", { staticClass: "flex md12 xs12" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "border-width": "0px 0px 1px 0px",
                                  "border-style": "solid",
                                  "border-color": "rgba(204, 204, 204, 1)",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "userManagement.user.authority.apps.title"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "va-row" }, [
                            _c("div", { staticClass: "flex md1 xs1" }),
                            _c(
                              "div",
                              { staticClass: "flex md10 xs10" },
                              [
                                _c("vuestic-multi-select", {
                                  attrs: {
                                    label: _vm.$t(
                                      "userManagement.user.authority.apps.selectDuplicate"
                                    ),
                                    optionKey: "app_name",
                                    clearable: "",
                                    options: _vm.appList,
                                  },
                                  model: {
                                    value: _vm.selectApps,
                                    callback: function ($$v) {
                                      _vm.selectApps = $$v
                                    },
                                    expression: "selectApps",
                                  },
                                }),
                                _c("div", { staticClass: "flex md1 xs1" }),
                              ],
                              1
                            ),
                          ]),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }